import { PatientReferenceIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { createTranslatedText, TranslatableText } from '@dreryk/react-common';

import { translationKeys } from './translations';

export const getPatientReferenceIdentifierTypeTranslatableText = (
   referenceIdentifier: PatientReferenceIdentifier | undefined
): TranslatableText => {
   if (!referenceIdentifier) {
      return createTranslatedText('-');
   }

   const externalIdentifier = referenceIdentifier.findExternalIdentifier();
   if (externalIdentifier) {
      return externalIdentifier.accept({
         visitPesel: () => translationKeys.identifierType.Pesel,
         visitGuardianPesel: () => translationKeys.identifierType.GuardianPesel,
         visitPassport: () => translationKeys.identifierType.Passport,
         visitNationalIdentificationNumber: () => translationKeys.identifierType.NationalIdentificationNumber,
      });
   }
   const medicalRecordNumber = referenceIdentifier.findMedicalRecordNumber();
   if (medicalRecordNumber) {
      return translationKeys.identifierType.MedicalRecordNumber;
   }

   return createTranslatedText('-');
};
